import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AdminApiService } from '../../../core/services/admin-api.service';

@Component({
    selector: 'app-admin-dashboard',
    templateUrl: './admin-dashboard.component.html'
})
export class AdminDashboardComponent {

    constructor(
        private router: Router,
        private adminApi: AdminApiService
    ) { }

    logout(): void {
        this.adminApi.logout().subscribe(
            () => {
                localStorage.removeItem('iosc_admin_token');
                localStorage.removeItem('iosc_admin_user');
                this.router.navigate(['/admin/login']);
            },
            () => {
                localStorage.removeItem('iosc_admin_token');
                localStorage.removeItem('iosc_admin_user');
                this.router.navigate(['/admin/login']);
            }
        );
    }
}